





















import Vue from 'vue';
import {Component, Emit, Prop} from "vue-property-decorator";
import AsiDialog from "./AsiDialog.vue";
import AsiFormErrors from "@/components/common/AsiFormErrors.vue";
import {Icon} from "@/helpers/icons";

@Component({
	components: {AsiFormErrors, AsiDialog}
})
export default class AsiDialogFormLayout extends Vue {

	@Prop({type: Boolean, required: true})
	public open!: boolean;

	@Prop({type: String, default: '50rem'})
	public maxWidth!: string;

	@Prop({type: String, default: null})
	public title!: string | null;

	@Prop({type: String, default: null})
	public subtitle!: string | null;

	@Prop({type: String, default: Icon.alert})
	public icon!: string;

	@Prop({type: Boolean, default: true})
	public valid!: boolean;

	@Prop({type: Array, default: () => []})
	public errors!: string[];

	@Prop({type: Boolean, default: false})
	public loading!: boolean;

	@Prop({type: Boolean, default: false})
	public unwrapped!: boolean;

	protected icons = Icon;

	@Emit('cancel')
	public cancel(event: Event): Event {
		return event;
	}

	@Emit('save')
	public save(event: Event): Event {
		return event;
	}

}
